import i18next from 'i18next';
import { draft, scheduled, completed, expired, canceled, actionRequired, awaitingConfirmation, pendingMatches } from '@/constants';

const stateOptions = [
    { value: 'AL', text: 'AL', fullname: 'Alabama' },
    { value: 'AK', text: 'AK', fullname: 'Alaska' },
    { value: 'AZ', text: 'AZ', fullname: 'Arizona' },
    { value: 'AR', text: 'AR', fullname: 'Arkansas' },
    { value: 'CA', text: 'CA', fullname: 'California' },
    { value: 'CO', text: 'CO', fullname: 'Colorado' },
    { value: 'CT', text: 'CT', fullname: 'Connecticut' },
    { value: 'DC', text: 'DC', fullname: 'District of Columbia' },
    { value: 'DE', text: 'DE', fullname: 'Delaware' },
    { value: 'FL', text: 'FL', fullname: 'Florida' },
    { value: 'GA', text: 'GA', fullname: 'Georgia' },
    { value: 'HI', text: 'HI', fullname: 'Hawaii' },
    { value: 'ID', text: 'ID', fullname: 'Idaho' },
    { value: 'IL', text: 'IL', fullname: 'Illinois' },
    { value: 'IN', text: 'IN', fullname: 'Indiana' },
    { value: 'IA', text: 'IA', fullname: 'Iowa' },
    { value: 'KS', text: 'KS', fullname: 'Kansas' },
    { value: 'KY', text: 'KY', fullname: 'Kentucky' },
    { value: 'LA', text: 'LA', fullname: 'Louisiana' },
    { value: 'ME', text: 'ME', fullname: 'Maine' },
    { value: 'MD', text: 'MD', fullname: 'Maryland' },
    { value: 'MA', text: 'MA', fullname: 'Massachusetts' },
    { value: 'MI', text: 'MI', fullname: 'Michigan' },
    { value: 'MN', text: 'MN', fullname: 'Minnesota' },
    { value: 'MS', text: 'MS', fullname: 'Mississippi' },
    { value: 'MO', text: 'MO', fullname: 'Missouri' },
    { value: 'MT', text: 'MT', fullname: 'Montana' },
    { value: 'NE', text: 'NE', fullname: 'Nebraska' },
    { value: 'NV', text: 'NV', fullname: 'Nevada' },
    { value: 'NH', text: 'NH', fullname: 'New Hampshire' },
    { value: 'NJ', text: 'NJ', fullname: 'New Jersey' },
    { value: 'NM', text: 'NM', fullname: 'New Mexico' },
    { value: 'NY', text: 'NY', fullname: 'New York' },
    { value: 'NC', text: 'NC', fullname: 'North Carolina' },
    { value: 'ND', text: 'ND', fullname: 'North Dakota' },
    { value: 'OH', text: 'OH', fullname: 'Ohio' },
    { value: 'OK', text: 'OK', fullname: 'Oklahoma' },
    { value: 'OR', text: 'OR', fullname: 'Oregon' },
    { value: 'PA', text: 'PA', fullname: 'Pennsylvania' },
    { value: 'RI', text: 'RI', fullname: 'Rhode Island' },
    { value: 'SC', text: 'SC', fullname: 'South Carolina' },
    { value: 'SD', text: 'SD', fullname: 'South Dakota' },
    { value: 'TN', text: 'TN', fullname: 'Tennessee' },
    { value: 'TX', text: 'TX', fullname: 'Texas' },
    { value: 'UT', text: 'UT', fullname: 'Utah' },
    { value: 'VT', text: 'VT', fullname: 'Vermont' },
    { value: 'VA', text: 'VA', fullname: 'Virginia' },
    { value: 'WA', text: 'WA', fullname: 'Washington' },
    { value: 'WV', text: 'WV', fullname: 'West Virginia' },
    { value: 'WI', text: 'WI', fullname: 'Wisconsin' },
    { value: 'WY', text: 'WY', fullname: 'Wyoming' },
];

const findState = (value) => stateOptions.find((state) => state.value === value);

function locationOptions() {
    return [
        { value: 'AL', text: 'AL', fullname: 'Alabama' },
        { value: 'AK', text: 'AK', fullname: 'Alaska' },
        { value: 'AZ', text: 'AZ', fullname: 'Arizona' },
        { value: 'AR', text: 'AR', fullname: 'Arkansas' },
        { value: 'CA', text: 'CA', fullname: 'California' },
        { value: 'CO', text: 'CO', fullname: 'Colorado' },
        { value: 'CT', text: 'CT', fullname: 'Connecticut' },
        { value: 'DC', text: 'DC', fullname: 'District of Columbia' },
        { value: 'DE', text: 'DE', fullname: 'Delaware' },
        { value: 'FL', text: 'FL', fullname: 'Florida' },
        { value: 'GA', text: 'GA', fullname: 'Georgia' },
        { value: 'HI', text: 'HI', fullname: 'Hawaii' },
        { value: 'ID', text: 'ID', fullname: 'Idaho' },
        { value: 'IL', text: 'IL', fullname: 'Illinois' },
        { value: 'IN', text: 'IN', fullname: 'Indiana' },
        { value: 'IA', text: 'IA', fullname: 'Iowa' },
        { value: 'KS', text: 'KS', fullname: 'Kansas' },
        { value: 'KY', text: 'KY', fullname: 'Kentucky' },
        { value: 'LA', text: 'LA', fullname: 'Louisiana' },
        { value: 'ME', text: 'ME', fullname: 'Maine' },
        { value: 'MD', text: 'MD', fullname: 'Maryland' },
        { value: 'MA', text: 'MA', fullname: 'Massachusetts' },
        { value: 'MI', text: 'MI', fullname: 'Michigan' },
        { value: 'MN', text: 'MN', fullname: 'Minnesota' },
        { value: 'MS', text: 'MS', fullname: 'Mississippi' },
        { value: 'MO', text: 'MO', fullname: 'Missouri' },
        { value: 'MT', text: 'MT', fullname: 'Montana' },
        { value: 'NE', text: 'NE', fullname: 'Nebraska' },
        { value: 'NV', text: 'NV', fullname: 'Nevada' },
        { value: 'NH', text: 'NH', fullname: 'New Hampshire' },
        { value: 'NJ', text: 'NJ', fullname: 'New Jersey' },
        { value: 'NM', text: 'NM', fullname: 'New Mexico' },
        { value: 'NY', text: 'NY', fullname: 'New York' },
        { value: 'NC', text: 'NC', fullname: 'North Carolina' },
        { value: 'ND', text: 'ND', fullname: 'North Dakota' },
        { value: 'OH', text: 'OH', fullname: 'Ohio' },
        { value: 'OK', text: 'OK', fullname: 'Oklahoma' },
        { value: 'OR', text: 'OR', fullname: 'Oregon' },
        { value: 'PA', text: 'PA', fullname: 'Pennsylvania' },
        { value: 'RI', text: 'RI', fullname: 'Rhode Island' },
        { value: 'SC', text: 'SC', fullname: 'South Carolina' },
        { value: 'SD', text: 'SD', fullname: 'South Dakota' },
        { value: 'TN', text: 'TN', fullname: 'Tennessee' },
        { value: 'TX', text: 'TX', fullname: 'Texas' },
        { value: 'UT', text: 'UT', fullname: 'Utah' },
        { value: 'VT', text: 'VT', fullname: 'Vermont' },
        { value: 'VA', text: 'VA', fullname: 'Virginia' },
        { value: 'WA', text: 'WA', fullname: 'Washington' },
        { value: 'WV', text: 'WV', fullname: 'West Virginia' },
        { value: 'WI', text: 'WI', fullname: 'Wisconsin' },
        { value: 'WY', text: 'WY', fullname: 'Wyoming' },
    ];
}

function raceOptions() {
    return [
        { value: 'americanindian', text: i18next.t('American Indian or Alaskan Native') },
        { value: 'asian', text: i18next.t('Asian') },
        { value: 'black', text: i18next.t('Black or African-American') },
        { value: 'hispaniclatino', text: i18next.t('Hispanic or Latino') },
        { value: 'multiple', text: i18next.t('Multiple races') },
        { value: 'hawaiian', text: i18next.t('Native Hawaiian or other Pacific Islander') },
        { value: 'white', text: i18next.t('White') },
        { value: 'other', text: i18next.t('Other') },
    ];
}
function genderOptions() {
    return [
        { value: 'female', text: i18next.t('Female') },
        { value: 'male', text: i18next.t('Male') },
        { value: 'other', text: i18next.t('Other') },
    ];
}
function languageOptions() {
    return [
        { value: 'arabic', text: i18next.t('Arabic') },
        { value: 'bengali', text: i18next.t('Bengali') },
        { value: 'dutch', text: i18next.t('Dutch') },
        { value: 'english', text: i18next.t('English') },
        { value: 'farsi', text: i18next.t('Farsi') },
        { value: 'french', text: i18next.t('French') },
        { value: 'german', text: i18next.t('German') },
        { value: 'gujarati', text: i18next.t('Gujarati') },
        { value: 'hindi', text: i18next.t('Hindi') },
        { value: 'italian', text: i18next.t('Italian') },
        { value: 'japanese', text: i18next.t('Japanese') },
        { value: 'javanese', text: i18next.t('Javanese') },
        { value: 'korean', text: i18next.t('Korean') },
        { value: 'mandarin', text: i18next.t('Mandarin') },
        { value: 'portuguese', text: i18next.t('Portuguese') },
        { value: 'russian', text: i18next.t('Russian') },
        { value: 'spanish', text: i18next.t('Spanish') },
        { value: 'thai', text: i18next.t('Thai') },
        { value: 'turkish', text: i18next.t('Turkish') },
        { value: 'urdu', text: i18next.t('Urdu') },
        { value: 'vietnamese', text: i18next.t('Vietnamese') },
    ];
}
function employmentLevelOptions() {
    return [
        { value: 'early', text: i18next.t('Early Career') },
        { value: 'intermediate', text: i18next.t('Intermediate/Senior') },
        { value: 'manager', text: i18next.t('Manager/Supervisor') },
        { value: 'director', text: i18next.t('Sr Management/Director') },
        { value: 'executive', text: i18next.t('Executive and above') },
    ];
}
function tenureOptions() {
    return [
        { value: 'underyear', text: i18next.t('Less than 1 year') },
        { value: 'one', text: i18next.t('1 to 2 years') },
        { value: 'three', text: i18next.t('3 to 5 years') },
        { value: 'six', text: i18next.t('6 to 10 years') },
        { value: 'eleven', text: i18next.t('11 to 15 years') },
        { value: 'fifteenplus', text: i18next.t('15+ years') },
    ];
}

function tags() {
    return {
        general: i18next.t('General'),
        'life-science': i18next.t('Life Science'),
        'physical-science': i18next.t('Physical Science'),
        'earth-science': i18next.t('Earth and Space Sciences'),
        engineering: i18next.t('Engineering and Manufacturing'),
        mathematics: i18next.t('Mathematics'),
        data: i18next.t('Data Analysis and Data Modeling'),
        'computer-science': i18next.t('Computer Science and Mixed Reality'),
        health: i18next.t('Health and Wellness'),
        english: i18next.t('English Language Arts'),
        'visual-arts': i18next.t('Visual and Performing Arts'),
        'social-studies': i18next.t('Social Studies and Humanities'),
        government: i18next.t('Government and Public Policy'),
        financial: i18next.t('Financial Literacy'),
        business: i18next.t('Business Education'),
    };
}

function tagOptions() {
    return Object.entries(tags()).map(([value, text]) => ({ value, text }));
}

function gradeLevelOptions() {
    return [
        { value: 'k', text: i18next.t('Kindergarten') },
        { value: '1', text: i18next.t('1st Grade') },
        { value: '2', text: i18next.t('2nd Grade') },
        { value: '3', text: i18next.t('3rd Grade') },
        { value: '4', text: i18next.t('4th Grade') },
        { value: '5', text: i18next.t('5th Grade') },
        { value: '6', text: i18next.t('6th Grade') },
        { value: '7', text: i18next.t('7th Grade') },
        { value: '8', text: i18next.t('8th Grade') },
        { value: '9', text: i18next.t('9th Grade') },
        { value: '10', text: i18next.t('10th Grade') },
        { value: '11', text: i18next.t('11th Grade') },
        { value: '12', text: i18next.t('12th Grade') },
    ];
}

function gradeBandOptions() {
    return [
        { value: 'k-2', text: i18next.t('K-2'), grades: ['k', '1', '2'] },
        { value: '3-5', text: i18next.t('3-5'), grades: ['3', '4', '5'] },
        { value: '6-8', text: i18next.t('6-8'), grades: ['6', '7', '8'] },
        { value: '9-12', text: i18next.t('9-12'), grades: ['9', '10', '11', '12'] },
    ];
}

function requestStatusOptions() {
    return [
        { value: draft, text: i18next.t('Draft') }, // Not ready to be seen by anyone
        { value: scheduled, text: i18next.t('Scheduled') }, // Employee and Educator are matched
        { value: expired, text: i18next.t('Expired') }, // Request was never scheduled but time has passed
        { value: completed, text: i18next.t('Completed') }, // Request has finished (meeting done)
        { value: canceled, text: i18next.t('Canceled') }, // Request no longer happening
        { value: pendingMatches, text: i18next.t('Pending Matches') }, // Request has been submitted
        { value: actionRequired, text: i18next.t('Action Required') }, // An employee has applied to a request
        { value: awaitingConfirmation, text: i18next.t('Awaiting Confirmation') }, // Request has been submitted
    ];
}

function timeSlotOptions() {
    return [
        {
            value: 'early-morning',
            text: i18next.t('6:00am-8:00am'),
        },
        {
            value: 'morning',
            text: i18next.t('8:00am-10:00am'),
        },
        {
            value: 'late-morning',
            text: i18next.t('10:00am-12:00pm'),
        },
        {
            value: 'afternoon',
            text: i18next.t('12:00pm-2:00pm'),
        },
        {
            value: 'late-afternoon',
            text: i18next.t('2:00pm-5:00pm'),
        },
        {
            value: 'evening',
            text: i18next.t('5:00pm-8:00pm'),
        },
    ];
}

function weekdayOptions() {
    return [
        {
            value: 'monday',
            text: i18next.t('Monday'),
        },
        {
            value: 'tuesday',
            text: i18next.t('Tuesday'),
        },
        {
            value: 'wednesday',
            text: i18next.t('Wednesday'),
        },
        {
            value: 'thursday',
            text: i18next.t('Thursday'),
        },
        {
            value: 'friday',
            text: i18next.t('Friday'),
        },
    ];
}

function weekdaysMap() {
    return {
        monday: i18next.t('Monday'),
        tuesday: i18next.t('Tuesday'),
        wednesday: i18next.t('Wednesday'),
        thursday: i18next.t('Thursday'),
        friday: i18next.t('Friday'),
    };
}

// NOTE: 2026-03-02: Request Types are considered deprecated,
// and should all default to 'Custom Request'. See CARE-1768.
function typeOptions() {
    return [{ value: '2', text: i18next.t('Custom Request') }];
}

function availabilityOptions() {
    return [
        { value: '1', text: i18next.t('I am flexible') },
        { value: '2', text: i18next.t("I'd like to share my general availability") },
    ];
}

const applicantDeclineReasons = () => {
    return [
        {
            value: 'not-a-fit',
            text: i18next.t('Industry/Area of expertise is not a fit for my request'),
        },
        {
            value: 'prefer-local',
            text: i18next.t('Prefer a career connection local to my area'),
        },
        {
            value: 'different-applicant',
            text: i18next.t('A different applicant is a better fit'),
        },
        {
            value: 'will-follow',
            text: i18next.t('I am planning on sending a new direct request to this applicant for something else'),
        },
        {
            value: 'other',
            text: i18next.t('Other reason'),
        },
    ];
};

function employeeRequestStatusOptions() {
    return [
        { value: 'open', text: i18next.t('Open') },
        { value: 'pending', text: i18next.t('Pending') },
        { value: 'assigned', text: i18next.t('Assigned') },
        { value: 'direct', text: i18next.t('Direct') },
    ];
}

function filterMetadata() {
    return {
        subject: tagOptions(),
        grade_level: gradeLevelOptions(),
        status: requestStatusOptions(),
        states: locationOptions(),
        type: typeOptions(),
        time: timeSlotOptions(),
        employee_status: employeeRequestStatusOptions(),
    };
}

export {
    applicantDeclineReasons,
    availabilityOptions,
    stateOptions,
    raceOptions,
    genderOptions,
    gradeLevelOptions,
    languageOptions,
    locationOptions,
    employmentLevelOptions,
    tenureOptions,
    tags,
    tagOptions,
    typeOptions,
    timeSlotOptions,
    requestStatusOptions,
    employeeRequestStatusOptions,
    weekdayOptions,
    weekdaysMap,
    gradeBandOptions,
    filterMetadata,
    findState,
};
